import * as actionTypes from '../../constants/action-types/school'

export const fetchSchoolSuccess = (school) => ({
    type: actionTypes.FETCH_SCHOOL_SUCCESS,
    payload: {school}
});
